export const PRINT_TYPE = {
  VALUE: {
    label: "Value Sheet Insert",
    value: "Value Sheet",
  },
  POSTCARD: {
    label: "Basic Postcard",
    value: "Solo Postcard",
  },
  BASIC_POSTCARD: {
    label: "Basic Postcard",
    value: "Basic Postcard",
  },
  MEGA_SHEET: {
    label: "Mega Sheet",
    value: "Mega Sheet",
  },
  DYNAMIC_POSTCARD: {
    label: "Dynamic Postcard",
    value: "Dynamic Postcard",
  },
};

export const ASSET_TYPE = {
  HERO: "hero_image",
  LARGE_HERO: "large_hero_image",
  MEDIUM_HERO: "medium_hero_image",
  FIXED_IMAGE: "fixed_image",
  COUPON: "coupon",
};

export const RRD_VALIDATION = {
  MAX_STORE_COPY_QNT: 50000,
};
